const constants = Object.freeze({
  LOCAL_STORAGE_ACCOUNT: 'itsTrackAccount',
  LOCAL_STORAGE_ACCESS_TOKEN: 'itsTrackAccessToken',
  LOCAL_STORAGE_AMOUNTS: 'lifetrackAmounts',
  LOCAL_STORAGE_SETTINGS: 'lifetrackUserSettings',
  LOCAL_STORAGE_ITS_MACROS_ACCESS_TOKEN: 'itsMacrosAccessToken',
  LOCAL_STORAGE_ITS_MACROS_ACCOUNT: 'itsMacrosAccount',
  LOCAL_STORAGE_ITS_MACROS_WELCOME_MESSAGE: 'itsMacrosWelcomeMessage',
  JOURNAL_MEALTIME_BREAKFAST: 'breakfast',
  JOURNAL_MEALTIME_SNACK1: 'snack1',
  JOURNAL_MEALTIME_LUNCH: 'lunch',
  JOURNAL_MEALTIME_SNACK2: 'snack2',
  JOURNAL_MEALTIME_DINNER: 'dinner',
  JOURNAL_MEALTIME_SNACK3: 'snack3',
  JOURNAL_ENTRY_CATEGORY_QUICKADD: 'quickAdd',
  JOURNAL_ENTRY_CATEGORY_FOOD: 'food',
  JOURNAL_ENTRY_CATEGORY_MEAL: 'meal',
  JOURNAL_ENTRY_CATEGORY_RECIPE: 'recipe',
  TERM_CATEGORY_FOOD: 'food',
  TERM_CATEGORY_MEAL: 'meal',
  TERM_CATEGORY_RECIPE: 'recipe',
  TERM_CATEGORY_TAKEAWAY: 'takeaway',
  TERM_CATEGORY_BRAND: 'brand',
});

export default constants;
